module.exports = __webpack_public_path__ + "media/images/summary_cards_snapshot-51f101cf.png";